import { render, staticRenderFns } from "./Goodslist.vue?vue&type=template&id=cf29d6fe&scoped=true&"
import script from "./Goodslist.vue?vue&type=script&lang=js&"
export * from "./Goodslist.vue?vue&type=script&lang=js&"
import style0 from "./Goodslist.vue?vue&type=style&index=0&id=cf29d6fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf29d6fe",
  null
  
)

export default component.exports